import {get} from 'lodash';
import gql from 'graphql-tag';
import {useQuery} from '@apollo/react-hooks';

const RESULTS_SIZE = 10;

const similarListingQuery = gql`
    query recommendedSimilarListingsResponse(
        $propertyId: String!
        $startDate: String
        $endDate: String
        $size: Int!
    ) {
        recommendedSimilarListingsResponse(
            propertyId: $propertyId
            startDate: $startDate
            endDate: $endDate
            size: $size
        ) {
            recommendedListings {
                listing {
                    averageRating
                    bedrooms
                    detailPageUrl
                    listingId
                    listingRequestParams {
                        arrival
                        departure
                    }
                    propertyMetadata {
                        headline
                    }
                    headlinePhoto(treatment: C4) {
                        uri
                    }
                    photos(treatment: C4) {
                        uri
                    }
                    sleeps
                    priceSummary {
                        formattedAmount
                        pricePeriodDescription
                    }
                    spaces {
                        bathrooms {
                            capacity
                        }
                    }
                    reviewCount
                }
            }
        }
    }
`;

export const useFetchSimilarListings = (searchParams, listingId) => {
    const {inputParams: {arrival, departure} = {}} = searchParams;
    const {data, loading} = useQuery(similarListingQuery, {
        errorPolicy: 'ignore',
        context: {
            headers: {
                'client-id': 'VRBO_SERP_TFR',
                'placement-id': 11
            }
        },
        variables: {
            propertyId: listingId,
            startDate: arrival,
            endDate: departure,
            size: RESULTS_SIZE
        }
    });

    let similarListings = get(
        data,
        'recommendedSimilarListingsResponse.recommendedListings',
        []
    );

    similarListings = similarListings.map((listing) => listing.listing);

    return {similarListings, similarListingsLoading: loading};
};
